import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import routerError from './error'
import routerRoleStatistics from './roleStatistics'
import routerTimeoutReminder from './timeoutReminder'
import routerDashboard from './dashboard'
import routerErrorInfo from './errorInfo'

const logPageLook = r => require(['@/views/logPage/logPageLook'], r) // 日志
const logPageAdd = r => require(['@/views/logPage/logPageAdd'], r) // 日志
const logPagedetial = r => require(['@/views/logPage/logPagedetial'], r) // 日志

const RegisterLook = r => require(['@/views/Register/RegisterLook'], r) // 审批登记表
const RegisterAdd = r => require(['@/views/Register/RegisterAdd'], r) // 审批登记表
const RegisterView = r => require(['@/views/Register/RegisterView'], r) // 审批登记表
const Registerdetial = r => require(['@/views/Register/Registerdetial'], r) // 审批登记表
const configManagement = r => require(['@/views/Register/configManagement'], r) // 配置登记
const systemConfig = r => require(['@/views/Register/systemConfig'], r) // 系统配置表

const homeView = r => require(['@/views/homeView.vue'], r) // 审批根组建

// 权限
const workFlowConfigTable = r => require(['@/views/workFlowConfig/table.vue'], r)
const workFlowConfig = r => require(['@/views/workFlowConfig/workFlowConfig.vue'], r)
const authority = r => require(['@/views/workFlowConfig/authority.vue'], r)
const workFlowShowOnling = r => require(['@/views/workFlowShowOnling.vue'], r)
const roleOfCalibration = r => require(['@/views/roleOfCalibration/index.vue'], r)

// 发起业务填写页面
const initiator = r => require(['@/views/initiator/index.vue'], r)
const initiatorMobile = r => require(['@/views/initiatorMobile/index.vue'], r)

// 审批业务填写页面
const approver = r => require(['@/views/approver/index.vue'], r)
const approverMobile = r => require(['@/views/approverMobile/index.vue'], r)


const remainTable = r => require(['@/views/mobile/remainTable.vue'], r)
const remainDetail = r => require(['@/views/mobile/remainDetail.vue'], r)

// 模板配置
const approverTemplateConfig = r => require(['@/views/approver/templateConfig.vue'], r)
const approverTemplateConfigMobile = r => require(['@/views/approverMobile/templateConfig.vue'], r)

// 待办交接单
const toDoList = r => require(['@/views/toDoList/manual.vue'], r) // 手动发起
const toDoAutomaticList = r => require(['@/views/toDoList/automatic.vue'], r) // 自动生成待办任务
const recordList = r => require(['@/views/toDoList/recordList.vue'], r) // 交接列表记录
const bv = r => require(['@/views/bv.vue'], r) //
const middlePage = r => require(['@/views/middlePage.vue'], r) //用于判断将要跳转到工联单下线看板页面的设备是PC还是Mobile,Mobile则拦截

// 变量配置
const myMaintain = r => require(['@/views/myMaintain.vue'], r) //



Vue.use(Router)

const router = new Router({
  routes: [
    {path: '/', component: homeView, redirect: '/homeView/workFlowConfig',meta: {auth: true,name: '不限制'}},

    /*无需验权 start*/
    {path: '/workFlowConfigTable', component: workFlowConfigTable, name: 'workFlowConfigTable',meta: {auth: true,name: '不限制'}},
    {path: '/toDoList', component: toDoList, name: 'toDoList',meta: {auth: true,name: '不限制'}},
    {path: '/toDoAutomaticList', component: toDoAutomaticList, name: 'toDoAutomaticList',meta: {auth: true,name: '不限制'}},
    {path: '/recordList', component: recordList, name: 'recordList',meta: {auth: true,name: '不限制'}},

    // 发起人
    {path: '/initiator', component: initiator, name: 'initiator',meta: {auth: true,name: '不限制'}},
    {path: '/initiatorMobile', component: initiatorMobile, name: 'initiatorMobile',meta: {auth: true,name: '不限制'}},
    // 审批人
    {path: '/approver', component: approver, name: 'approver',meta: {auth: true,name: '不限制'}},
    {path: '/approverTemplateConfig', component: approverTemplateConfig, name: 'approverTemplateConfig',meta: {auth: true,name: '不限制'}},
    {path: '/approverTemplateConfigMobile', component: approverTemplateConfigMobile, name: 'approverTemplateConfigMobile', meta: {auth: true,name: '不限制'}},
    {path: '/approverMobile', component: approverMobile, name: 'approverMobile',meta: {auth: true,name: '不限制'}},
    // 配置变量 myMaintain
    {path: '/myMaintain', component: myMaintain, name: 'myMaintain',meta: {auth: true,name: '不限制'}},
    /*无需验权 end*/

    //日志
    {
      path: '/homeView',
      component: homeView,
      children: [
        {
          path: '/',
          component: workFlowConfig,
          redirect: '/homeView/workFlowConfig',
          meta: {auth: true,name: '不限制'}
        },
        // 模板查询
        {
          path: "workFlowConfig",
          component: workFlowConfig,
          name: "workFlowConfig",
          meta: {auth: true,name: '不限制'}
        },
        // 角色校验
        {
          path: "roleOfCalibration",
          component: roleOfCalibration,
          name: "roleOfCalibration",
          meta: {auth: true,name: '不限制'}
        },
        // 超时提醒
        ...routerTimeoutReminder,
        // 角色补人
        ...routerRoleStatistics,
        // 趋势看板
        ...routerDashboard,
        // 异常信息展示
        ...routerErrorInfo,
        // 运维登记 == 开始
        {path: 'logPageLook', component: logPageLook, name: 'logPageLook', meta: { auth: true,name: '运维登记'},},
        {path: 'authority', component: authority, name: 'authority', meta: {auth: true,name: '运维登记'}},
        {
          path: '/RegisterView', component: RegisterView, meta: {auth: true,name: '运维登记'},
          children: [
            {path: 'RegisterLook', component: RegisterLook, name: 'RegisterLook', meta: { auth: true,name: '运维登记'},},
          ]
        },
        {path: 'bv', component: bv, name: 'bv', meta: { auth: true,name: '运维登记'},},
        {path: 'configManagement', component: configManagement, name: 'configManagement', meta: { auth: true,name: '运维登记'},},
        {path: 'systemConfig', component: systemConfig, name: 'systemConfig', meta: { auth: true,name: '运维登记'},},
        // 运维登记 == 结束
      ],
      meta: {name: '不限制'}
    },
    {path: '/logPageAdd', component: logPageAdd, meta: { auth: true,name: '运维登记'},},
    {path: '/logPagedetial', component: logPagedetial, meta: {auth: true,name: '运维登记'}},
    {path: '/RegisterAdd', component: RegisterAdd, meta: { auth: true,name: '运维登记'},},
    {path: '/Registerdetial', component: Registerdetial, meta: {auth: true,name: '运维登记'}},
    {path: '/workFlowShowOnling', component: workFlowShowOnling,name: workFlowShowOnling,meta: {auth: true,name: '不限制'}},
    {path: '/remainTable', component: remainTable, name: 'remainTable',meta: {keepAlive: true,name: '不限制'}},
    {path: '/remainDetail', component: remainDetail, name: 'remainDetail',meta: {keepAlive: true,name: '不限制'}},
    {path: '/middlePage', component: middlePage, name: 'middlePage',meta: {keepAlive: true,name: '不限制'}},
    ...routerError, // 错误路由，包括401、404、500等
  ]
});

const verifyAuthority = (to, from, next) => {
  const {routeList, bpmAdministrator,permission} = store.state.userInfo;
  // console.log("routeList",routeList);
  // console.log("bpmAdministrator",bpmAdministrator);
  // console.log("permission",permission);

  if(to.matched.some(item => item.meta.notMatch)){
    next();
  } else if(routeList.length === 0){
    next({path: '/401'})
  } else if(to.matched.length === 0){
    next({path: '/404'})
  } else {
    if(to.matched.every(item => item.meta.name === '不限制')){
      if(to.name === 'workRelationEdit' || to.name === 'workWhiteList'){
        if(bpmAdministrator){
          next();
        } else {
          next({path: '/401'})
        }
      }
      if(to.name === 'workFlowDetail'){
        console.log(permission);
        if(permission){
          next();
        } else {
          next({path: '/401'})
        }
      }
      next();
    } else {
      // console.log('匹配路由');
      let findRoute = false;
      to.matched.forEach((item)=>{
        const matchName = item.meta.name;
        findRoute = routeList.some(item => item.name === matchName);
      })
      if(findRoute){
        //console.log('有权限');
        next()
      } else {
        next({path: '/401'})
      }
    }
  }
}

router.beforeEach((to, from, next) => {
  // 已登录
  if (store.state.hasOwnProperty('userInfo')) {
    // console.log('已登录');
    if(store.state.userInfo.hasOwnProperty('routeList')){
      // console.log('已登录,有路由列表');
      store.dispatch('getUserMenu', {}).then(response => {
        verifyAuthority(to,from,next);
      })
    } else {
      // console.log('已登录,无路由列表');
      store.dispatch('getUserMenu', {}).then(response => {
        verifyAuthority(to,from,next);
      })
    }
  }
  // 未登录
  else {
    // console.log('未登录');
    store.dispatch('getUserMenu', {}).then(response => {
      verifyAuthority(to,from,next);
    });
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js